import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, Input } from "@angular/core";
import { FormArray, FormBuilder } from "@angular/forms";
import { LoadingBarService } from "@ngx-loading-bar/core";

import Swal from "sweetalert2";

import {
  HeaderService,
  ServiceOrderService,
  FiltersService
} from "../../../shared";

@Component({
  selector: "app-service-order-edit",
  templateUrl: "./service-order-edit.component.html",
  styleUrls: ["./service-order-edit.component.scss"]
})
export class ServiceOrderEditComponent implements OnInit {
  title = "EDIÇÃO DE ORDEM DE SERVIÇO";
  subtitle = "Utilize os campos abaixo para editar a ordem de serviço";
  urlBack = "/panel/service-order/list";

  @Input() currentUrl;

  newServiceOrder = this.fb.group({
    idFsRequisicao: [""],
    cdBandeira: [""],
    cdFornecedor: [""],
    cdFilial: [""],
    cdTpServico: ["2"],
    items: this.fb.array([]),
    cdProduto: [""],
    dsObservacao: [""],
    lojaNova: ["não"]
  });

  flagsArr = [];
  storesArr = [];
  equipmentsArr = [];
  providersArr = [];

  actualDate;

  returnLink;

  id;

  equipments = [];

  constructor(
    private headerService: HeaderService,
    private loadingBarService: LoadingBarService,
    private filtersService: FiltersService,
    private serviceOrderService: ServiceOrderService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;

      this.returnLink = `/panel/service-order/return/${this.id}`;
    }
  }

  ngOnInit() {

    this.headerService.changeTitle("Edição de ordem de serviço");
    this.headerService.changeSubtitle("");
    this.headerService.changeDatePicker(false);
    this.setActualDate();

    this.filtersService.listFlags().subscribe(response => {
      this.flagsArr = response["data"];
    });

    // Select de equipamentos
    // this.filtersService.listEquipments().subscribe(response => {
    //   this.equipmentsArr = response["data"];
    // });

    //Tabela de equipamentos
    this.serviceOrderService.getServiceOrder(this.id).subscribe(response => {
      this.equipments = response["data"].items;
    });

    this.serviceOrderService.getServiceOrder(this.id).subscribe(response => {

      let codProduto: number = response["data"].items.length > 0 ?  
                                 response["data"].items[0].cdProduto :
                                  0;

      this.getStores(response["data"].loja.cdLogomarca);
      this.getServiceProviders(codProduto);
      
      this.newServiceOrder.patchValue({
        idFsRequisicao: this.id,
        cdBandeira: response["data"].loja.cdLogomarca,
        cdFornecedor: response["data"].cdFornecedor,
        cdFilial: response["data"].cdFilial,
        dsObservacao: response["data"].dsObservacao,
        cdProduto: codProduto
      });
      
      let control = <FormArray>this.newServiceOrder.controls.items;
      control.removeAt(0);
      control.push(
        this.fb.group({
          cdProduto: [response["data"].items[0].cdProduto],
          qtItem: ["1"]
        })
      );
      
      this.loadingBarService.complete();
    });
  }

  getStores(providerId) {
    this.newServiceOrder.patchValue({
      cdFilial: ""
    });

    this.filtersService
      .listStores(`?cdLogomarca=${providerId}`)
      .subscribe(response => {
        this.storesArr = response["data"];
      });
  }

  getServiceProviders(equipmentId) {
    let cdOperador = JSON.parse(localStorage.getItem('userId'));
    let control = <FormArray>this.newServiceOrder.controls.items;
    control.removeAt(0);
    control.push(
      this.fb.group({
        cdProduto: [equipmentId],
        qtItem: ["1"]
      })
    );

    this.newServiceOrder.patchValue({
      cdFornecedor: ""
    });

    this.filtersService
      .listProviders(`?cdProduto=${equipmentId}&cdOperador=${cdOperador}`)
      .subscribe(response => {
        this.providersArr = response["data"];
      });
  }

  getEquipments(providerId) {
    this.filtersService
      .listEquipments(`?cdFornecedor=${providerId}`)
      .subscribe(response => {
        this.equipmentsArr = response["data"];
      });

  }

  setActualDate() {
    let date = new Date(),
      day = ("0" + date.getDate()).slice(-2),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      year = date.getFullYear();

    this.actualDate = `${day}/${month}/${year}`;
  }

  resetValues() {
    this.newServiceOrder.patchValue({
      cdBandeira: "",
      cdFornecedor: "",
      cdFilial: "",
      cdTpServico: "",
      cdProduto: "",
      dsObservacao: ""
    });
  }

  saveServiceOrder() {
    this.loadingBarService.start();

    this.serviceOrderService
      .addServiceOrders(this.newServiceOrder.value)
      .subscribe(response => {
        this.loadingBarService.complete();

        this.resetValues();

        Swal({
          type: "success",
          title: "Ordem de serviço cadastrado",
          text: `Ordem de Serviço nº ${response['data']['idFsRequisicao']} alterada com sucesso`,
          confirmButtonText: "Ok, entendi!",
          confirmButtonClass: "sweet-button",
          buttonsStyling: false
        }).then(() => {
          this.router.navigate([this.urlBack]);
        });
      });
  }
}
